<script setup lang="ts">
import { reactive } from 'vue'
import { SLUG_CATEGORY_NEWS } from '~/resources/news'
import type { NewsData } from '~/composables/news/interface'
import NewsItem from '~/components/common/news/news-item.vue'
import { useSwiper } from '~/composables/common/use-swiper'
import { useNews } from '~/composables/news/use-news'

const { fetchAllCategoryDataSideBar } = useNews()
const dataNews = reactive<NewsData[]>([])
const { modules, SPACE_BETWEEN_SWIPER } = useSwiper()

const newsHighLightSlug = SLUG_CATEGORY_NEWS.HIGH_LIGHT
fetchAllCategoryDataSideBar(newsHighLightSlug, dataNews, 0, 9)
</script>
<template>
  <div v-if="dataNews[0] && dataNews[0]?.data.length" class="news-highlight">
    <div class="news-highlight__title">
      Tin Nổi Bật
      <div class="news-highlight__slider">
        <div class="news-highlight__pagination-bar">
          <div class="news-highlight__pagination"></div>
        </div>
        <div class="news-highlight__arrow">
          <div class="news-highlight__prev swiper-button-prev">
            <span class="arrow icon-chevron-left"></span>
          </div>
          <div class="news-highlight__next swiper-button-next">
            <span class="arrow icon-chevron-right"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="news-highlight__content">
      <div class="news-highlight__slider">
        <Swiper
          :modules="modules"
          :navigation="{
            nextEl: '.news-highlight__next',
            prevEl: '.news-highlight__prev'
          }"
          :grid="{
            rows: 3,
            fill: 'row'
          }"
          :spaceBetween="SPACE_BETWEEN_SWIPER.LARGE"
        >
          <SwiperSlide v-for="(item, index) in dataNews[0]?.data" :key="index">
            <NewsItem :item="item" :categoryName="dataNews[0]?.category.name" />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/desktop/pages/news/news-highlight.scss';
</style>
